 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		42: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		42: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"1":"action-result-page~all-authors-page~allcomments-page~author-page~calendar-archive~change-password-pa~c50fb2ee","2":"action-result-page~all-authors-page~allcomments-page~author-page~calendar-archive~currency-page~dail~8daf0c50","3":"vendors~action-result-page~all-authors-page~allcomments-page~author-page~calendar-archive~currency-p~0ec3898e","6":"change-password-page~edit-profile-page~profile-page~restore-password-page","7":"allcomments-page~record-comments-page~record-page","8":"vendors~allcomments-page~record-comments-page~record-page","10":"all-authors-page~author-page","11":"allcomments-page~record-comments-page","13":"action-result-page","14":"all-authors-page","15":"allcomments-page","17":"author-page","20":"calendar-archive","21":"change-password-page","22":"currency-page","23":"daily-news","24":"day-archive","25":"edit-profile-page","26":"format-page","27":"home-page","28":"last-news","29":"mentions-page","30":"new-home-page","31":"old-home-page","32":"photos-videos-page","33":"polyfills","34":"polyfills-dom","35":"profile-page","36":"projects-page","38":"record-comments-page","39":"record-page","40":"restore-password-page","41":"rubric-page","43":"search-page","45":"subscription-page","46":"subscription-promo-page","47":"tag-page","48":"theme-page","50":"vendors~polyfills-core-js","54":"weather-page"}[chunkId]||chunkId) + "." + {"1":"06cab23","2":"ba8d388","3":"8b9ac47","4":"ad8f2b4","6":"d353eb0","7":"d9dda64","8":"f24ac1a","9":"70160fd","10":"a7b2c1c","11":"21bde6e","12":"017a6df","13":"376087b","14":"e972ad3","15":"8e1ac73","17":"755eb40","20":"ca21a11","21":"e3f4ad4","22":"a7ac9cd","23":"a2cb837","24":"9d3551c","25":"7450a25","26":"60ba966","27":"aa18c28","28":"00c03b4","29":"d4a8bb9","30":"9e1665f","31":"8f26380","32":"b4f1a3e","33":"3d765f3","34":"8d2aa79","35":"2e03ec0","36":"078c834","38":"23fed26","39":"95bd2ca","40":"7947fdb","41":"8a1bb41","43":"03713a5","45":"ddd15bc","46":"5898cbf","47":"dc179e7","48":"f40b8ed","50":"13149ff","54":"3d2375a","55":"05ea6ff","56":"6f9a92f","57":"02ecc85","58":"4265d95","59":"3961bb0","60":"b4c2824","61":"aaefefc","62":"1877cc9"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1,"2":1,"3":1,"6":1,"7":1,"8":1,"10":1,"11":1,"22":1,"26":1,"29":1,"30":1,"31":1,"32":1,"36":1,"41":1,"45":1,"46":1,"47":1,"48":1,"54":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"1":"action-result-page~all-authors-page~allcomments-page~author-page~calendar-archive~change-password-pa~c50fb2ee","2":"action-result-page~all-authors-page~allcomments-page~author-page~calendar-archive~currency-page~dail~8daf0c50","3":"vendors~action-result-page~all-authors-page~allcomments-page~author-page~calendar-archive~currency-p~0ec3898e","6":"change-password-page~edit-profile-page~profile-page~restore-password-page","7":"allcomments-page~record-comments-page~record-page","8":"vendors~allcomments-page~record-comments-page~record-page","10":"all-authors-page~author-page","11":"allcomments-page~record-comments-page","13":"action-result-page","14":"all-authors-page","15":"allcomments-page","17":"author-page","20":"calendar-archive","21":"change-password-page","22":"currency-page","23":"daily-news","24":"day-archive","25":"edit-profile-page","26":"format-page","27":"home-page","28":"last-news","29":"mentions-page","30":"new-home-page","31":"old-home-page","32":"photos-videos-page","33":"polyfills","34":"polyfills-dom","35":"profile-page","36":"projects-page","38":"record-comments-page","39":"record-page","40":"restore-password-page","41":"rubric-page","43":"search-page","45":"subscription-page","46":"subscription-promo-page","47":"tag-page","48":"theme-page","50":"vendors~polyfills-core-js","54":"weather-page"}[chunkId]||chunkId) + "." + {"1":"969bddf","2":"97d8edd","3":"2faa9d9","4":"31d6cfe","6":"8ae3d37","7":"f27c480","8":"c5710c1","9":"31d6cfe","10":"6b4851e","11":"cd18f8b","12":"31d6cfe","13":"31d6cfe","14":"31d6cfe","15":"31d6cfe","17":"31d6cfe","20":"31d6cfe","21":"31d6cfe","22":"c445ff9","23":"31d6cfe","24":"31d6cfe","25":"31d6cfe","26":"5f3d33c","27":"31d6cfe","28":"31d6cfe","29":"036c2dc","30":"8b9079e","31":"be24b96","32":"4c0ea91","33":"31d6cfe","34":"31d6cfe","35":"31d6cfe","36":"18ece5b","38":"31d6cfe","39":"31d6cfe","40":"31d6cfe","41":"295b754","43":"31d6cfe","45":"3d7f238","46":"89b0001","47":"27e8667","48":"4ca5bb6","50":"31d6cfe","54":"7fb42eb","55":"31d6cfe","56":"31d6cfe","57":"31d6cfe","58":"31d6cfe","59":"31d6cfe","60":"31d6cfe","61":"31d6cfe","62":"31d6cfe"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://static.ngs.ru/fontanka/dist/legacy/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
